/* eslint-disable no-useless-escape */

import { isUrl } from './../helpers'

import { 
  ON_CHANGE_FORM,
  POST_FORM_REQUEST,
  POST_FORM_DESIGN_REQUEST,
  ON_PAUSE,
  ON_START_DESIGN
} from "./../reducers/app"

export const parseName = (username) => {
  return username.replace( / +/g, ' ' ).replace(/[^a-яА-Яa-z ]+/gi,"")
}

const isValidName = (value) => {
  return value.length > 4
}

const isValidEmail = (value) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(value).toLowerCase())
}

export const onChangeName = (e) => {
  const start = e.target.selectionStart
  const name = parseName(e.target.value)
  e.target.value = name
  e.target.selectionStart = start
  e.target.selectionEnd = start
  return {
    type: ON_CHANGE_FORM,
    payload: { name, nameIsValid:  isValidName(name) ? '' : 'invalid'}
  }
}

export const onChangeEmail = (e) => {
  // const start = e.target.selectionStart
  const email = e.target.value//.replace( / +/g, '' ).replace(/[^0-9A-Za-z.@\-_]+/gi,"")
  // e.target.value = email
  // e.target.selectionStart = start
  // e.target.selectionEnd = start
  return {
    type: ON_CHANGE_FORM,
    payload: { email, emailIsValid:  isValidEmail(email) ? '' : 'invalid'}
  }
}

export const onChangeAgree = (value) => ({
  type: ON_CHANGE_FORM,
  payload: { checked: value }
})

export const onChangeAgreeFinal = (value) => ({
  type: ON_CHANGE_FORM,
  payload: { checkedFinal: value }
})


export const onChangeLink = (e) => {
  const field = e.target.getAttribute('id')
  return {
  type: ON_CHANGE_FORM,
  payload: { [field]: e.target.value, [`${field}IsValid`]:  isUrl(e.target.value) ? '' : 'invalid' }
}}

export const onChangeResultLink = (e) => {
  const field = e.target.getAttribute('id')
  return {
  type: ON_CHANGE_FORM,
  payload: { [field]: e.target.value, [`${field}IsValid`]:  isUrl(e.target.value) ? '' : 'invalid' }
}}

export const onSendForm = (e) => ({
  type: POST_FORM_REQUEST
})

export const onStartDesign = (e) => ({
  type: ON_START_DESIGN,
  payload: { counter: '1:59’00' }
})

export const onPause = (e) => ({
  type: ON_PAUSE
})

export const onSendFormDesign = (e) => ({
  type: POST_FORM_DESIGN_REQUEST
})


// WEBPACK FOOTER //
// ./src/actions/app.js